import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { useBulkUploadSharedKnowledgeFilesService } from '@/services/sharedFiles';
import { ArrowUpToLine } from 'lucide-react';
import { useRef, type ChangeEvent, type FC } from 'react';
import { toast } from 'sonner';
import { FileTable } from './FileTable/FileTable';
import { ManageGroupsModal } from './ManageGroupsModal';

export const SharedKnowledgePage: FC = () => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const { uploadFiles, isUploading, error } =
    useBulkUploadSharedKnowledgeFilesService();

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      const fileArray = Array.from(files);
      try {
        await uploadFiles(fileArray);
        toast.success(`${fileArray.length} file(s) uploaded successfully!`);
      } catch (error) {
        console.error('Upload failed:', error);
        toast.error('Upload failed. Please try again.');
      }
      event.target.value = '';
    }
  };

  return (
    <FlexCol gap="4">
      <FlexRow alignItems="center" justifyContent="between">
        <Text variant="header2">Shared Knowledge</Text>
        <FlexRow gap="2">
          <Button onClick={handleUploadClick} disabled={isUploading}>
            <ArrowUpToLine />
            {isUploading ? 'Uploading...' : 'Upload Files'}
          </Button>
          <input
            ref={fileInputRef}
            type="file"
            onChange={handleFileChange}
            style={{ display: 'none' }}
            accept=".pdf,.xlsx,.xls,.docx,.doc,.txt,.csv"
            multiple
          />
          <ManageGroupsModal />
        </FlexRow>
      </FlexRow>
      {error && <div className="text-red-500">{error.message}</div>}
      <FileTable onUploadFiles={handleUploadClick} />
    </FlexCol>
  );
};
